/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Judges_ConfirmInputs */



/**
* | output |
* | --- |
* | "Trigger a judge directory sync now? Members not validly listed lose Judge and Sheriff." |
*
* @param {Admin_Sync_Judges_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_judges_confirm = /** @type {((inputs?: Admin_Sync_Judges_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Judges_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déclencher une synchronisation de l'annuaire des arbitres maintenant ? Les membres absents ou expirés perdent Judge et Sheriff.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Activar una sincronización del directorio de jueces ahora? Los miembros ausentes o caducados pierden Judge y Sheriff.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Disparar uma sincronização do diretório de juízes agora? Membros ausentes ou expirados perdem Judge e Sheriff.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviare ora una sincronizzazione dell'elenco dei giudici? I membri assenti o scaduti perdono Judge e Sheriff.")
	return /** @type {LocalizedString} */ ("Trigger a judge directory sync now? Members not validly listed lose Judge and Sheriff.")
});